<template>
  <div class="">
    <!-- <settings-menu></settings-menu> -->
    <!-- <div class="card"> -->

      <!-- <form> -->
        <!-- <div class="card-content"> -->
          <vue-tabs class="row settings-tabs full-height-tabs"
                      direction="vertical"
                      type="tabs"
                      v-model="tabName"
                      @tab-change="handleTabChange" >
            <!-- Users -->
            <v-tab :title="$t('settingsPages.userSettings')" tabId="first" class="text-left" disabled>
            </v-tab>
            <v-tab :title="$t('settingsPages.myProfile')"class="text-left">
              <user-form @on-submit="onUserSubmit" :callback="updateList" :userId="user.id"></user-form>
            </v-tab>
            <v-tab :title="$t('settingsPages.users')" class="text-left active" >
              <template v-if="selectedUser != false">
                <user-form @on-submit="onUserSubmit" :callback="updateList" :userId="selectedUser"></user-form>
              </template>
              <template v-else>
                 <users-list ref="userList" :callback="getUser" ></users-list>
              </template>
            </v-tab>
            <!-- General -->
            <v-tab :title="$t('settingsPages.general')" class="text-left" disabled>
            </v-tab>
            <v-tab :title="$t('settingsPages.companyDetails')" class="text-left">

              <company-details :modeldata="model" :countries="defaultData.countries" :taxesData="taxes" :tabRefresh="tabName" v-on:updateModelData=
                  "updateModelData"></company-details>

            </v-tab>
            <v-tab :title="$t('settingsPages.dateTime')" class="text-left">
              <div class="card">
                <div class="card-content">
                  <datetime-form :modeldata="model" :defaultData="defaultData"></datetime-form>
                </div>
              </div>
            </v-tab>
            <v-tab :title="$t('settingsPages.currency')" class="text-left">
              <div class="card">
                <div class="card-content">
                  <currency-form :modeldata="model" :currencylist="defaultData.currencies" :currencyformatlist="defaultData.currency_display_format"></currency-form>
                </div>
              </div>
            </v-tab>
        <!--     <v-tab title="Product options" class="text-left">
              <div class="card">
                <div class="card-content">
                  <product-options :modeldata="model"></product-options>
                </div>
              </div>
            </v-tab> -->
            <!-- Accounting -->
            <v-tab :title="$t('settingsPages.accounting')" class="text-left"  disabled>
            </v-tab>
            <v-tab :title="$t('settingsPages.tax')" class="text-left">
              <div class="card">
                <div class="card-content">
                  <tax-form :modeldata="model" :defaultData="defaultData" :taxesData="taxes" v-on:setSelectedTab=
                  "setSelectedTab" v-on:setTaxes="setTaxes"></tax-form>
                </div>
              </div>
            </v-tab>
         <!--    <v-tab :title="$t('settingsPages.payment')" class="text-left">
              <div class="card">
                <div class="card-content">
                  <el-collapse >
                    <el-collapse-item title="Pay U" name="Pay U" >
                      <form>
                        <div class="form-group">
                          <label>{{$t('settingsPayment.publicKey')}}</label>
                          <input type="text" name="" class="form-control" :placeholder="$t('settingsPayment.publicKey')" >
                        </div>
                        <div class="form-group">
                          <label>{{$t('settingsPayment.privateKey')}}</label>
                          <input type="text" name="" class="form-control" :placeholder="$t('settingsPayment.privateKey')" >
                        </div>
                      </form>
                    </el-collapse-item>
                  </el-collapse>
                  <p> </p>
                </div>
              </div>
            </v-tab> -->
            <v-tab :title="$t('settingsPages.orderingMng')" class="text-left">

              <ordering-management :modeldata="model" :defaultData="defaultData"></ordering-management>
              <p> </p>

            </v-tab>
            <v-tab :title="$t('settingsPages.infoPages')" class="text-left">
              <div class="card">
                <div class="card-content">
                  <info-pages></info-pages>
                  <p> </p>
                </div>
              </div>
            </v-tab>
            <v-tab :title="$t('settingsPages.loyalty')" class="text-left">
              <div class="row">
                <div class="col-lg-9 col-md-10 col-sm-12">
                  <div class="card">
                    <div class="card-content ">
                      <reward-form :modeldata="model" :defaultData="defaultData"></reward-form>
                    </div>
                  </div>
                </div>
              </div>
            </v-tab>
            <v-tab :title="$t('settingsPages.push')" class="text-left">
              <div class="card">
                <div class="card-content">
                  <push-notifications :modeldata="model.push_notifications"></push-notifications>
                </div>
              </div>
            </v-tab>
            <v-tab :title="$t('settingsPages.tips')" class="text-left">
              <div class="card">
                <div class="card-content">
                  <tips-form :modeldata="model" :defaultData="defaultData" :taxesData="taxes"></tips-form>
                </div>
              </div>
            </v-tab>
            <!-- Subscription -->
            <!--
            <v-tab :title="$t('settingsPages.subscription')" class="text-left"disabled>
            </v-tab>
            <v-tab :title="$t('settingsPages.myPlan')" class="text-left" >
              <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-8">
                  <div class="card">
                    <div class="card-content">
                      <form class="text-center pad-bt-15">
                        <h4 class="purple">{{$t('settingsPlans.plan1Title')}}</h4>
                        <hr>
                        <h3 class="text-orange">{{$t('settingsPlans.plan1Rate')}}</h3>
                        <hr>
                        <p class="plan-desc">{{$t('settingsPlans.plan1Description')}}
                        </p>
                        <button class="btn btn-purple btn-fill mar-to-10">{{$t('settingsPlans.current')}}</button>
                        <p></p>
                      </form>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-8">
                  <div class="card">
                    <div class="card-content ">
                      <form class="text-center pad-bt-15">
                        <h4 class="purple">{{$t('settingsPlans.plan2Title')}}</h4>
                        <hr>
                        <h3 class="text-orange">{{$t('settingsPlans.plan2Rate')}}</h3>
                        <hr>
                        <p class=" plan-desc">{{$t('settingsPlans.plan2Description')}}</p>
                        <button class="btn btn-purple mar-to-10">{{$t('settingsPlans.switch')}}</button>
                        <p></p>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </v-tab>
          -->
          </vue-tabs>

        <!-- </div> -->

        <div class="card-footer text-center">
          <p> </p>
        </div>
      <!-- </form> -->

    <!-- </div> -->
  </div>
</template>
<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, Menu, MenuItem, MenuItemGroup, TimeSelect} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import VueTabs from 'vue-nav-tabs'
  import SettingsMenu from './SettingsMenu'
  import UsersList from './Users/Users.vue'
  import UserForm from './Users/UserForm.vue'
  import OrderingManagement from './../OrderingManagement/OrderingManagement'
  import RewardForm from './../RewardProgram/RewardProgramForm.vue'
  import InfoPages from './../InfoPages/InfoPages.vue'
  import TaxForm from './Tabs/Taxes.vue'
  import TipsForm from './Tabs/Tips.vue'
  import CompanyDetails from './Tabs/CompanyDetails.vue'
  import CurrencyForm from './Tabs/Currency.vue'
  import DatetimeForm from './Tabs/DateTime.vue'
  import PushNotifications from './Tabs/PushNotifications.vue'
  // import ProductOptions from './Tabs/ProductOptions.vue'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(VueTabs)
  Vue.use(Menu)
  Vue.use(MenuItem)
  Vue.use(MenuItemGroup)
  Vue.use(DataTables)
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input,
      [Menu.name]: Menu,
      [MenuItem.name]: MenuItem,
      [MenuItemGroup.name]: MenuItemGroup,
      [TimeSelect.name]: TimeSelect,
      SettingsMenu,
      UserForm,
      OrderingManagement,
      RewardForm,
      InfoPages,
      TaxForm,
      TipsForm,
      CompanyDetails,
      CurrencyForm,
      DatetimeForm,
      PushNotifications,
      UsersList
      // ProductOptions
    },
    computed: {
      ...mapFields(['name', 'description', 'sku', 'category_id', 'sub_category_id', 'date_from', 'date_to', 'price', 'quantity'])
    },
    data () {
      return {
        pickerOptions1: {},
        tabName: 'My Profile',
        currentTab: '',
        selectedUser: false,
        pickerNames: ['date_from', 'date_to'],
        days: [
          this.$t('days.monday'),
          this.$t('days.tuesday'),
          this.$t('days.wednesday'),
          this.$t('days.thursday'),
          this.$t('days.friday'),
          this.$t('days.saturday'),
          this.$t('days.sunday')
        ],
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '23:59'
        },
        mainCategories: [],
        optionTypes: ['checkbox', 'radiobox', 'dropdown'],
        locations: [],
        model: {},
        user: JSON.parse(this.$session.get('userData')),
        defaultData: {
          'available_languages': {},
          'countries': {},
          'currencies': {},
          'currency_display_format': [],
          'date_formats': [],
          'time_formats': [],
          'timezones': {}
        },
        timeformats: [
          { format: 'H:mm', example: '15:40' },
          { format: 'h:mm a', example: '3:40 pm' }
        ],
        dateformats: [
          { format: 'DD/MM/YYYY', example: '15/03/2018' },
          { format: 'MM/DD/YYYY', example: '03/15/2018' },
          { format: 'MMMM D, YYYY', example: 'March 15, 2018' }
        ],
        newLocation: {
          'street': '',
          'city': '',
          'state': '',
          'country': ''
        },
        modelValidations: {
        },
        modelValidate: {},
        taxes: []
      }
    },
    created () {
      var data = {
        token: this.$session.get('token')
      }
      var self = this
      var companyID = this.$session.get('selectedCompany')

      this.apiRequest('/listdefaults', 'GET', data, function (response) {
        if (response.status === true) {
          self.defaultData = response.data[0]
        }
      })

      this.apiRequest('/settings/general/' + companyID, 'GET', data, function (response2) {
        if (response2.status === true) {
          self.model = response2.data[0]
        }
      })

      var taxesData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest('/settings/taxes', 'GET', taxesData, function (response) {
        if (response.status === true) {
          self.taxes = response.data
        }
      })

      let tab = this.$session.get('selectedTab')
      // console.warn('tab: ' + tab)
      if (tab !== undefined && tab !== '') {
        this.tabName = tab
        this.$session.set('selectedTab', '')
      }
    },
    methods: {
      getData () {
        return []
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          this.$emit('on-submit', this.registerForm, isValid)
        })
      },
      addNewLocation () {
        let locationCopy = this.newLocation
        let newRow = []
        newRow = this.newLocation
        newRow.location_id = ''
        newRow.location_id = 'new_' + Math.round((Math.random() * 10000))

        if (this.locations === undefined) {
          this.locations = []
        }

        console.warn(newRow)

        this.locations.push(newRow)
        this.newLocation = locationCopy

        console.warn(this.locations)
      },
      goToRecordUser (row, event, column) {
        this.globalGoToRecord(row, event, column, '/user/edit/')
      },
      onUserSubmit (model, isValid) {
      },
      updateList () {
        console.warn('---- update list ----')
        this.selectedUser = false
        this.$refs.userList.getData()
      },
      getUser (id) {
        this.selectedUser = id
      },
      handleTabChange (tabIndex, newTab, oldTab) {
        // console.warn(newTab)
        this.selectedUser = false
      },
      setSelectedTab (value) {
        this.tabName = value
      },
      setTaxes (value) {
        this.taxes = value
      },
      updateModelData (data) {
        this.model = data
      }
    }
  }
</script>
<style>
  .upload-demo input[type="file"]{ display: none; }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Settings.vue